(function () {
  function initToggle(host) {
    var sectionId = host.dataset.sectionId;
    if (!sectionId) return;
    var wrap = document.querySelector('.gm-collection-grid-wrap.section-' + sectionId);
    if (!wrap) return;

    // The initial view is rendered server-side: main-collection-product-grid.liquid
    // puts gm-view-list on the wrapper when the "Default view" setting is List.
    // Doing it here instead meant the setting was ignored whenever the toggle was
    // hidden, because this script only loads alongside the toggle buttons.
    var buttons = host.querySelectorAll('.gm-view-toggle__btn');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.dataset.view;
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        wrap.classList.toggle('gm-view-list', view === 'list');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.gm-view-toggle-host').forEach(initToggle);
  });

  // Shopify theme editor re-runs sections; re-initialise on shopify:section:load
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.gm-view-toggle-host').forEach(initToggle);
  });
})();
